import { defineMessages } from 'react-intl'

const scope = `procurify.components.AmountFraction`

export default defineMessages({
  costAmountFractionAriaLabel: {
    id: `${scope}.costAmountFractionAriaLabel`,
    defaultMessage: 'Cost fraction',
  },
  quantityAmountFractionAriaLabel: {
    id: `${scope}.quantityAmountFractionAriaLabel`,
    defaultMessage: 'Quantity fraction',
  },
})
